/**
 * Devices
 * Devices
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 0 = And, 1 = Or, 2 = Not
 */
export enum LogicalOperator {
    And = 'and',
    Or = 'or',
    Not = 'not'
}

